// extracted by mini-css-extract-plugin
export default {"inner":"ReportSheetsSkeleton_inner_WgSfZ"};